export const atou = (data: string) => decodeURIComponent(escape(atob(data)));

export const utoa = (data: string) => btoa(unescape(encodeURIComponent(data)));

export const objectToBase64: <T>(data: T) => string = (data) =>
  btoa(JSON.stringify(data));
